.loadingContainer {
  min-height: 15em;
  height: 100%;
}
